import { useEffect } from "react";
import { startChampionshipClipAutoUpload } from "../../utils/championshipClipUploader";

/** Drains match clips saved on this phone from any screen of the app. */
export default function ChampionshipClipAutoUpload() {
  useEffect(() => startChampionshipClipAutoUpload(), []);
  return null;
}
